import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostBySlug } from '../data/blogPosts';

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return (
      <section className="section page-section">
        <h1>Artículo no encontrado</h1>
        <Link to="/blog" className="btn btn-outline">Volver al blog</Link>
      </section>
    );
  }

  return (
    <section className="section page-section blog-post">
      <nav className="breadcrumb">
        <Link to="/blog">Blog</Link> / {post.title}
      </nav>
      <span className="blog-category">{post.category}</span>
      <h1>{post.title}</h1>
      <p className="blog-post-date">{new Date(post.date).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      <img src={post.image} alt={post.title} className="blog-post-image" />
      <p className="blog-post-content">{post.content}</p>
      <Link to="/blog" className="btn btn-outline">← Volver al blog</Link>
    </section>
  );
}
